
import React from 'react';
import ReactDOM from "react-dom/client";
import constants from '../helpers/constants.js';
import configureStore from '../helpers/configure-store.js';
import { MDTApp } from '../actions/bootAction.js';
import { uniqueId, get, find, isEmpty, isArray, includes } from 'lodash';
import jwt_decode from 'jwt-decode';
import { MDTApi } from '../services/mdtapi.js';
import { MDTAnalytics } from '../services/mdtanalytics.js';
import { getUrlParameter } from '../helpers/commonUtils.js';
import MDTNotification from '../components/molecules/mdt-notification/index.js';

import {
    getCustomerInfoCall,
    getDefaultCustomer,
    getDownloadHideConfig,
    getFeatureConfiguration,
    getOpenIdConfiguration,
    getUserDetails,
    getUserInfoCall,
    getUserPermissions,
    getDefaultContract,
    getCountryList,
    fetchAPINotificationPreferencesList
} from '../services/meService.js';

import { setCountryList } from '../reducers/commonData.js';

const store = configureStore();
const FORM_ENCODED_CONTENT_TYPE = 'application/x-www-form-urlencoded; charset=UTF-8';
const CLIENT_CREDENTIALS = 'mdtcJs:medtronic';
const refreshInterval = 50;
let refreshToken = null;

let myOrderToken = getUrlParameter("redirect-token");
refreshToken = myOrderToken ? myOrderToken : sessionStorage.getItem('apiRefreshToken');

let decodedAccessToken = null,
    accessToken = null,
    refreshTokenTimer = null,
    url = '',
    userInitResolve = false;

let meState = {
    AUTHENTICATING: false,
    OPENID_CONFIG: false,
    LOGGED_IN: false,
    USER_DETAILS: false,
    HAS_PERMISSIONS: false,
    HAS_CUSTOMERS: false,
    HAS_RESOURCE_RIGHTS: false,
    FETCHING_PERMISSIONS: false,
    FETCHING_RESOURCE_RIGHTS: false,
    LOGIN_ERROR: false,
    APPLY_ONBOARDING: false
}

export function getOpenIdConfigurationSucess(data) {
    return { type: constants.GET_OPENID_CONFIGURATION_SUCCESS, data };
}

export function getCustomerDetailsSuccess(data) {
    return { type: constants.GET_CUSTOMER_DETAILS_SUCCESS, data };
}

export function setDistributorValue(data) {
    return { type: constants.SET_DISTRIBUTOR_VALUE, data };
}

export function sessionSucess(data) {
    return { type: constants.SESSION_SUCCESS, data };
}

export function meStateUpdate(data) {
    return { type: constants.ME_STATE_UPDATE, data };
}

export function userpermissionsCheck(dispatch, getState, resolve, appId, buId) {
    return (dispatch, getState) => {
        dispatch(checkUserPermissions(dispatch, getState, resolve, appId, buId));
    }
}

export function setDefaultCustomer(data) {
    localStorage.setItem('customerISOCode', get(data, 'customer.soldTo.address.country.isocode', ''));
    return { type: constants.SET_DEFAULT_CUSTOMER, data };
}

export function setDefaultContracts(data) {
    return { type: constants.SET_DEFAULT_CONTRACTS, data };
}

export function setUserType(data) {
    return { type: constants.SET_USER_TYPE, data };
}


export function setSupportedSuppliers(data) { 
    return {type: constants.SET_SUPPORTED_SUPPLIERS, payload: data };
}

export function stateUpdate(state) {
    state = state || {};
    return (dispatch, getState) => {
        Object.assign(meState, state);
        dispatch(meStateUpdate(meState));

    }
}
export function loadInit(resolve) {
    return (dispatch, getState) => {
        dispatch(stateUpdate({ AUTHENTICATING: true }));
        return getOpenIdConfiguration().then(data => {
            dispatch(stateUpdate({ OPENID_CONFIG: true }));
            dispatch(getOpenIdConfigurationSucess(data));
            MDTApp.updateMDTSettings("openIdConfig", data);
            dispatch(getThemeUpdate());
            getCountryList().then(data => {
                dispatch(setCountryList(data));
            });
        }).catch(error => {
            throw (error);
        }).then(data => {
            initializeToken(dispatch, getState, resolve);
        });
    }
}

function getPreferredCustomer(appId, buId, currentState) {
    // check if a preference exists for that App / BU combination
    let userDetails = currentState.meDetails.user || {};
    // let prefObj = find(currentState.meDetails.customerPreferences || {}, { customerid: userDetails.id, appid: appId, buid: buId });
    let prefObj = find(currentState.meDetails.customerPreferences, { userid: userDetails.sub, appid: appId, buid: buId });
    // if does not exist, let's create it and add it to the preference list
    if (prefObj) {
        return prefObj.customerid;
    } else {
        return null;
    }
}

function loadDefaultCustomer(dispatch, getState, resolve, appId, buId) {
    return (dispatch, getState) => {
        return getDefaultCustomer().then(data => {
            let pathVars = MDTApi.getPathvariables();
            let customerId = data && data.customer.id;
            pathVars.customerid = customerId;
            if (customerId) {
                dispatch(setDefaultCustomer(data));
                dispatch(setPreferredCustomer(customerId, appId, buId));
                dispatch(MDTAnalytics.cacheCustomTrackingInfo());
            } else {
                MDTApp.goto(MDTApp.getSetting('links.portal'));
            }
        }).catch(error => {
            throw (error);
        }).then(data => {
            dispatch(defaultContract());
            dispatch(checkResourceRights(appId, buId, resolve));
        })
    }
}

function getAPINotificationPreferencesList(comHubConfig) {
    return (dispatch, getState) => {
        return fetchAPINotificationPreferencesList().then(res => {
            let data = res.find(i => (i.code === comHubConfig)) || {};

            if(!isEmpty(data)) {
                data = JSON.parse(data.value || '{}');
            }
            dispatch(setSupportedSuppliers(data))
        }).catch(error => {
            throw (error);
        });
    }
}

function defaultContract() {
    return (dispatch, getState) => {
        return getDefaultContract().then(data => {
            dispatch(setDefaultContracts(data));
        }).catch(error => {
            throw (error);
        })
    }
}



export function setPreferredCustomer(customerId, appId, buId, redirectUrl) {
    // init customerPreference array
    return (dispatch, getState) => {
        let customerPreferences = getState().meDetails.customerPreferences || [],
            user = getState().meDetails.user || {};
        // check that preference not already exists for that App / BU combination
        let prefObj = find(customerPreferences, {
            userid: user.sub,
            appid: appId,
            buid: buId
        });

        // if does not exist, let's create it and add it to the preference list
        if (!prefObj) {
            prefObj = {
                userid: user.sub,
                appid: appId,
                buid: buId,
                customerid: customerId
            };

            customerPreferences.push(prefObj);
            dispatch(getCustomerDetailsSuccess(customerPreferences));
        }

        // if it exists, just change the customerId in object ref
        if (prefObj && prefObj.hasOwnProperty('customerid')) {
            prefObj.customerid = customerId;
        }

        // Store new preferences in local storage
        localStorage.setItem("customer", JSON.stringify(customerPreferences));
        if (redirectUrl) {
            MDTApp.goto(redirectUrl);
        }
    }
}

function getUserPermissionsSuccess(data) {
    return { type: constants.USER_PERMISSIONS_SUCCESS, data };
}

function checkUserPermissions(dispatch, getState, resolve, appId, buId) {
    return (dispatch, getState) => {
        let currentState = getState();
        let customerId = getPreferredCustomer(appId, buId, currentState),
            appSetting = window.MDTSetting,
            fetchCustomer = MDTApp.getSetting('login.fetchCustomer', true),
            internalUserFetchCustomer = MDTApp.getSetting('login.internalUserFetchCustomer', true);

        // If no preferred customer can be found, let's load a default one set for the user / bu / app
        if ((!fetchCustomer || (currentState.meDetails.user.isinternal == "True" && !internalUserFetchCustomer)) && currentState.meDetails.meState.LOGGED_IN) {
            dispatch(checkResourceRights(appId, buId, resolve));
            return;
        } else if (!customerId && currentState.meDetails.meState.LOGGED_IN ) {
            // dispatch(checkResourceRights(appId, buId));
            customerId = dispatch(loadDefaultCustomer(dispatch, getState, resolve, appId, buId));
            return;
        }

        dispatch(stateUpdate({ FETCHING_PERMISSIONS: true }));
        let pathVars = MDTApi.getPathvariables();
        pathVars.customerid = customerId;
        if (currentState.meDetails.meState.LOGGED_IN) {
            getUserPermissions(customerId).then(data => {
                dispatch(getUserPermissionsSuccess(data));
                dispatch(stateUpdate({ FETCHING_PERMISSIONS: false, HAS_PERMISSIONS: true }));
                dispatch(setDefaultCustomer(data));
                dispatch(getAPINotificationPreferencesList('SupplierList_ComHubConfig_CENT'));
                dispatch(defaultContract());
                dispatch(MDTAnalytics.cacheCustomTrackingInfo());
                dispatch(getFormConfig());
                if (MDTApp.getSetting('autoCheckPermissions', true) && MDTApp.getSetting('login.autoCheckRights', false)) {
                    dispatch(checkResourceRights(appId, buId, resolve))
                }
            }).catch(error => {
                throw (error);
            });
        }
    }
}



export function featureConfiguration(customerId) {
    return (dispatch, getState) => {
        let territoryId = get(getState(), 'meDetails.customer.territory.id', undefined);
        let countryId = get(getState(), 'meDetails.customer.soldTo.address.country.isocode', undefined);
        let appid = window.MDTSetting.appid || window.appSettings.appid;
        const applyOnBoard = get(getState(), 'meDetails.meState.APPLY_ONBOARDING', false);

        // NOTE: If the app is territory dependent and there is no customer and no territory defined get
        // the default one. This will be used for user configuration and other generic pages 20220609:Alevale
        if (window.MDTSetting.appNeedsTerritory && (!territoryId && !customerId) && applyOnBoard === false) {
            return getDefaultCustomer().then(res => {
                territoryId = get(res, 'customer.territory.id', undefined);
                countryId = get(res, 'customer.soldTo.address.country.isocode', undefined);
                appid = window.MDTSetting.appid || window.appSettings.appid;
                dispatch(setDefaultCustomer(res));
                return getFeatureConfiguration(territoryId, countryId, appid)
            }).then(data => {
                dispatch(getAPINotificationPreferencesList('SupplierList_ComHubConfig'));
                dispatch(saveFeatureConfiguration(data));
            }).catch(error => {
                dispatch(saveFeatureConfiguration({}));
            })
        }

        return getFeatureConfiguration(territoryId, countryId, appid).then(data => {
            dispatch(saveFeatureConfiguration(data));
        }).catch(error => {
            console.error('An error occurred:', error);
            console.error('trace error:', error.stack);
            dispatch(saveFeatureConfiguration({}));
        })
    }
}

function saveFeatureConfiguration(data) {
    let config = [];
    let configValue = {};
    try {
        config = data.reduce((result, item) => {
            if(!isEmpty(result[item.feature])){
                console.warn(`${item.feature} configuration is available more than one time in response, please correct the configuration data.`);
             }
            configValue[item.feature] =  Object.assign(item, {configuration: item.configuration });
            result = MDTApp.mergeDeep(result, configValue);
            return result;
        }, {});
        let defaultCartType = get(config, 'DefaultCartType.configuration.cartType', 'DEFAULT');
        MDTApi.setDefaultPathVar("defaultCartType", defaultCartType);
    } catch (error) {

    }
    return { type: constants.FEATURE_CONFIGURATION, config };
}

function getFormConfig() {
    return (dispatch, getState) => {
        getDownloadHideConfig().then(data => {
            let langArr = !isEmpty(data) && isArray(data.fields) ? data.fields.map(item => item.id) : [];
            dispatch(setDownloadConfig(langArr));
        }).catch(error => {
            dispatch(setDownloadConfig([]));
        })
    }
}

function setDownloadConfig(data) {
    return { type: constants.FORM_CONFIG_HIDE_DOWNLOAD, data };
}

export function getResourceRightsSuccess(data) {
    return { type: constants.USER_RESOURCE_RIGHT, data };
}

export function getResourceRights(apikey) {

    return MDTApi.call(apikey, {
        method: 'GET'
    });
}

export function getRoleAccess(appId, rolePermission) {
    return (dispatch, getState) => {
        const access = getState().AccountDetails.user.access || [];

        return access.length > 0 && !!access.find(app => app.appId === appId && app.roles.find(role => role.permissions && role.permissions.includes(rolePermission)));
    };
}


export function checkResourceRights(appId, buId, resolve) {
    return (dispatch, getState) => {
        let currentState = getState();
        let customerId = getPreferredCustomer(appId, buId, currentState);
        let apiKey = 'api.login.resourceRights';
        let data = customerId ? { customerid: customerId } : {};

        if (customerId) {
            apiKey = 'api.login.resourceRightsForCustomer';
        }
        //To Do: call logout functionlity
        function logout() {
            // RiotBus.trigger('me.logout')
        }
        dispatch(stateUpdate({ FETCHING_RESOURCE_RIGHTS: true }));
        let pathVars = MDTApi.getPathvariables();
        pathVars.customerid = customerId;
        //apiKey = processPathVariables(MDTApp.getSetting(apiKey), pathVars);
        getResourceRights(apiKey).then(data => {
            dispatch(getResourceRightsSuccess(data));
            console.log("get resource check");
            dispatch(stateUpdate({ FETCHING_RESOURCE_RIGHTS: false, HAS_RESOURCE_RIGHTS: true }));
            resolve && resolve();
        }).catch(error => {
            throw (error);
        }).then(data => {
            const currentState = getState();
            console.log("currentState");
            console.log(currentState);
        });
    }
}

function initializeToken(dispatch, getState, resolve, fromTimeout) {
    let sessionObj = initializeFromStorage();
    if (refreshToken) {
        refreshAccessToken(getState()).then(response => {
            handleRefreshSuccess(response, dispatch, getState, resolve, fromTimeout);
            restartRefreshTimer(dispatch, getState, resolve);
            dispatch(getCustomerDetailsSuccess(sessionObj.customerPreferencesValue));
            dispatch(setDistributorValue(sessionObj.distributorValue));
            dispatch(MDTApp.authenticate());
        }).catch(error => {
            handleRefreshError(dispatch, getState);
            throw (error);
        })
    } else {
        // NOTE: This are the pages that a user can go to without being logged in, so bypass all 20240621:Alevale
        if (MDTApp.whitelistedUrl(getState().location)) {
            return resolve();
        }
        if (window.MDTSetting.appid !== window.MDTSetting.authAppId) {
            sessionStorage.setItem("depthURL", window.location.href);
            MDTApp.goto(MDTApp.getSetting('links.login'));
        // NOTE: This is in place to do the redirect to the right page for landing links See feature S-98849 20220822:Alevale
        } else if (!window.location.href.includes(MDTApp.getSetting('links.login'))) {
            sessionStorage.setItem('depthURL', window.location.href);
            MDTApp.goto(MDTApp.getSetting('links.login'));
        } else {
            return resolve();
        }

    }

}


function refreshAccessToken(currentState) {


    let payload = {
        refresh_token: refreshToken,
        grant_type: 'refresh_token',
        client_id: 'mdtcJs',
        client_secret: 'medtronic',
        acr_values: 'tenant:' + window.MDTSetting.pathVars.buid
    };


    const searchParams = MDTApp.createQueryStringParam(payload);
    window.refreshTokenFlag = false;
    return MDTApi.call('api.login.token', {
        method: 'POST',
        data: searchParams,
        headers: {
            'Accept': 'application/json',
            'Content-Type': FORM_ENCODED_CONTENT_TYPE
        }
    }, {}, !window.showloaderFirstTime);
    // const response = await fetch(
    //     url, {
    //         method: 'POST',
    //         contentType: FORM_ENCODED_CONTENT_TYPE,
    //         body: searchParams,

    //
    //     })
    // return response.json();
}


export function handleRefreshSuccess(response, dispatch, getState, resolve, fromTimeout) {
    const decodedToken = jwt_decode(response.access_token);
    const applyOnBoarding = decodedToken.ApplyOnBoarding === 'true';
    dispatch(stateUpdate({ LOGGED_IN: true, AUTHENTICATING: false, APPLY_ONBOARDING: applyOnBoarding }));
    setTokens(response.access_token, response.refresh_token);
    if (!applyOnBoarding) getUserInfo(dispatch, getState, resolve, fromTimeout);
    window.refreshTokenFlag = true;
    return true;

}

function handleRefreshError(dispatch, getState) {
    //to do logout on refresh token expire
    // let refreshToken = store.refreshToken;
    dispatch(stateUpdate({ LOGGED_IN: false, AUTHENTICATING: false }));
    removeTokens();
    removePoPendingOrders();
    removeCustomerSelected();
    MDTApp.goto(MDTApp.getSetting('links.login'));

}



export function restartRefreshTimer(dispatch, getState, resolve) {
    refreshTokenTimer = setTimeout(() => {
        initializeToken(dispatch, getState, resolve, true)
    }, refreshInterval * 1000)
}

function removeTokens() {
    localStorage.removeItem('apiToken');
    sessionStorage.removeItem('apiRefreshToken');
    sessionStorage.removeItem('deviceRegistrationId');
    sessionStorage.removeItem('allEventsStore');
    sessionStorage.removeItem('allPageLoadData');
    sessionStorage.removeItem('transactions');
    sessionStorage.removeItem('transaction');
    refreshToken = null;

}

const removePoPendingOrders = () => {
    localStorage.removeItem('poPendingOrders');
}

const removeCustomerSelected = () => {
    localStorage.removeItem('CustomerSelected');
}

function setTokens(accessTokenStorage, refreshTokenStorage) {
    if (accessTokenStorage) {
        accessToken = accessTokenStorage;
        // if (!accessTokenStorage){
        //     debugger
        // }

        localStorage.setItem('apiToken', accessTokenStorage);
    }

    if (refreshTokenStorage) {
        refreshToken = refreshTokenStorage;
        sessionStorage.setItem('apiRefreshToken', refreshTokenStorage);
        refreshToken = refreshTokenStorage;
    }
    return { type: constants.REFRESH_TOKEN_SUCCESS, refreshTokenStorage };

}



function initializeFromStorage() {
    // grab existing state from local storage
    let customer = localStorage.getItem('customer');
    let distributor = localStorage.getItem('distributor');
    // restore the me stores' state
    setTokens(localStorage.getItem('apiToken'), refreshToken ? refreshToken : sessionStorage.getItem('apiRefreshToken'));
    let customerPreferences = customer ? JSON.parse(customer) : null;
    distributor = distributor ? JSON.parse(distributor) : null;

    return {
        customerPreferencesValue: customerPreferences,
        distributorValue: distributor
    }
}



let notificationRoot = null;
function getUserInfo(dispatch, getState, resolve, fromTimeout) {
    // NOTE: It feels like there's no need to call the user over and over again from the token refresh call
    // if there were to be because this function has side effects let's try to look for data from the application
    // state and pull the data from there to save the user calls from the BE 20230530:Alevale
    if (fromTimeout) {
        return
    }

    return getUserInfoCall().then(response => {
        window.showloaderFirstTime = true;

    // NOTE: Handling Role changes 20230530:Alevale
        if (response.isRolesCountMax == 'true' && sessionStorage.getItem('isRolesCountMax') != 'true' && !!Object.keys(window.t).length) {
            let msg = window.t('countMaxContent');
            let props = {
                contents: [msg],
                defaultOpen: true,
                toggle: function() {
                    sessionStorage.setItem('isRolesCountMax', "true")
                },
                notifyType: "error",
                title: window.t('countMaxTitle'),
                key: uniqueId('id_')
            };
            let elementName = "msgNotify";
            let element = document.getElementById(elementName);
            if (!element) {
                element = document.createElement("div");
                element.setAttribute("id", "msgNotify");
                document.body.appendChild(element);
            }
            if (!notificationRoot) {
                notificationRoot = ReactDOM.createRoot(document.getElementById(elementName));
            }
            // TODO: Refactor this, add <MDTNotification /> to the
            //  skeleton and write here to redux just if it should
            //  be shown or not  20231027:Alevale
            notificationRoot.render(<MDTNotification { ...props } />);
            }

            dispatch(stateUpdate({ USER_DETAILS: true }));

        // NOTE: Dealing with culture changes 20230525:Alevale
            let culture = response.culture;
            let cachedCulture = localStorage.getItem('I18N_LANGUAGE_CMS');
            culture = culture ? culture.replace('_', '-') : 'en';
            let hyphenizedCulture = culture;
            localStorage.setItem('I18N_LANGUAGE', culture);
            updateHtmlLang(hyphenizedCulture);
            culture = culture.replace('-', '_'); //we need to ensure the locale we request is an underscore -- this matches how the locales are stored in CMS
            localStorage.setItem('I18N_LANGUAGE_CMS', culture);
            if (culture !== cachedCulture && window.next18) {
                window.next18.changeLanguage(culture);
            }
            dispatch(updateHyphenizedCulture(hyphenizedCulture));

        // NOTE: Saving the user info in the store 20230525:Alevale
            dispatch(userInfoSucess(response));

            (!userInitResolve && resolve) && resolve(getState);
            userInitResolve = true;
        // NOTE: This updates the user in analytics with whatever changes have happen, move this logic somewhere else 20230525:Alevale
            getUserDetails().then(userResponse => {
                dispatch(storeUserDetails(userResponse));
                dispatch(MDTAnalytics.cacheUser(MDTApp.getDeviceType()));
            }).catch(error => {
                throw (error);
            });
            decodedAccessToken = jwt_decode(localStorage.getItem('apiToken'));
            dispatch(setUserType(decodedAccessToken.isinternal));
        }).catch(error => {
        throw (error);

    })
}
function updateHtmlLang(lang) {
    if(!!lang){
        document.documentElement.setAttribute('lang',lang.toUpperCase()); // Update user selected lang in HTML tag
        // Checking _satellite variable is available on DOM or not
        if (typeof _satellite != "undefined" && typeof _satellite.track === 'function') {
            _satellite?.track('OneTrust');
        }

    }
    return;
}
function updateHyphenizedCulture(data){
    return { type: constants.UPDATE_HYPHENIZED_CULTURE, data };
}
function updateUserCulture(data){
     return { type: constants.UPDATE_LANGUAGE, data };
}
export function userInfoSucess(data) {
    return { type: constants.USER_INFO_SUCCESS, data };
}

export function userInfoSucessLanguageUpdate(data) {
    return (dispatch, getState) => {
         dispatch(updateUserCulture(data));
         let hyphenizedCulture = data ? data.replace('_', '-') : 'en';
         updateHtmlLang(hyphenizedCulture);
         dispatch(updateHyphenizedCulture(hyphenizedCulture));
    }
}

export function storeUserDetails(data) {
    return { type: constants.ACCOUNT_USER_DETAILS_UPDATE, data };
}

export function customerInfoSucess(data) {
    return { type: constants.CUSTOMER_INFO_SUCCESS, data };
}

export function getThemeUpdate() {
    return (dispatch, getState) => {
        // Restricting the update of Theme from localStorage Since Themes can be different in each app
        // let theme = localStorage.getItem("theme") || "";
        dispatch(themeUpdateOnStore());
    }

}
export function themeUpdate(data) {
    return (dispatch, getState) => {
        // Restricting the update of Theme to localStorage Since Themes can be different in each app
        //localStorage.setItem("theme", data);
        dispatch(themeUpdateOnStore(data));
    }

}

export function themeUpdateOnStore(data) {
    return { type: constants.APPLICATION_THEME, data };
}


export function getCustomers() {
    return (dispatch, getState) => {
        let currentState = getState();
        if (currentState.meDetails.isInternal.toLowerCase() === "true" && window.MDTSetting.appid == constants.GCDMS){
            return false;
        }
        getCustomerInfoCall().then(response => {
            dispatch(stateUpdate({ HAS_CUSTOMERS: true, LOGGED_IN: true }));
            dispatch(customerInfoSucess(response));
        }).catch(error => {
            throw (error);
            //to do logout

        })
    }
}